"use client";

import React, { useEffect, useRef, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/simple-carousel";
import { Progress } from "@/components/ui/progress";
const videoArray = ["/assets/images/story/shop-story-1.mp4", "/assets/images/story/shop-story-2.mp4", "/assets/images/story/shop-story-3.mp4", "/assets/images/story/shop-story-4.mp4"];
export function InstaStory() {
  const [carouselApi, setCarouselApi] = useState<any>(null);
  const videoRefs = useRef<HTMLVideoElement[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeProgress, setActiveProgress] = useState(0);
  const pressStartRef = useRef<number | null>(null);
  const tapThreshold = 200;
  useEffect(() => {
    if (!carouselApi) return;
    const onSelect = () => {
      setActiveIndex(carouselApi.selectedScrollSnap());
      setActiveProgress(0);
    };
    carouselApi.on("select", onSelect);
    return () => carouselApi.off("select", onSelect);
  }, [carouselApi]);
  useEffect(() => {
    const currentVideo = videoRefs.current[activeIndex];
    if (!currentVideo) return;
    currentVideo.currentTime = 0;
    currentVideo.play().catch(() => {});
    const onTimeUpdate = () => {
      if (currentVideo.duration) {
        const prog = currentVideo.currentTime / currentVideo.duration * 100;
        setActiveProgress(prog);
      }
    };
    const onEnded = () => {
      carouselApi && carouselApi.scrollNext();
    };
    currentVideo.addEventListener("timeupdate", onTimeUpdate);
    currentVideo.addEventListener("ended", onEnded);
    return () => {
      currentVideo.removeEventListener("timeupdate", onTimeUpdate);
      currentVideo.removeEventListener("ended", onEnded);
    };
  }, [activeIndex, carouselApi]);
  const pauseActiveVideo = () => {
    const currentVideo = videoRefs.current[activeIndex];
    if (currentVideo) currentVideo.pause();
  };
  const resumeActiveVideo = () => {
    const currentVideo = videoRefs.current[activeIndex];
    if (currentVideo) {
      currentVideo.play().catch(() => {});
    }
  };
  const handleLeftMouseDown = () => {
    pressStartRef.current = Date.now();
    pauseActiveVideo();
  };
  const handleLeftMouseUp = () => {
    const pressDuration = Date.now() - (pressStartRef.current || 0);
    resumeActiveVideo();
    if (pressDuration < tapThreshold && carouselApi) {
      carouselApi.scrollPrev();
    }
    pressStartRef.current = null;
  };
  const handleRightMouseDown = () => {
    pressStartRef.current = Date.now();
    pauseActiveVideo();
  };
  const handleRightMouseUp = () => {
    const pressDuration = Date.now() - (pressStartRef.current || 0);
    resumeActiveVideo();
    if (pressDuration < tapThreshold && carouselApi) {
      carouselApi.scrollNext();
    }
    pressStartRef.current = null;
  };
  return <Carousel className="w-full max-w-xs relative" setApi={setCarouselApi} fade opts={{
    align: "center",
    loop: true
  }} data-sentry-element="Carousel" data-sentry-component="InstaStory" data-sentry-source-file="insta-story.tsx">
      <div className="absolute top-4 left-4 right-4 z-10 flex gap-2">
        {videoArray.map((_, index) => {
        let value = 0;
        if (index < activeIndex) value = 100;else if (index === activeIndex) value = activeProgress;else value = 0;
        return <Progress key={`progress-${index}`} value={value} className="h-2 flex-1 rounded-full bg-neutral-200/30" />;
      })}
      </div>
      <CarouselContent className="relative h-[400px]" data-sentry-element="CarouselContent" data-sentry-source-file="insta-story.tsx">
        {videoArray.map((videoSrc, index) => <CarouselItem key={`carousel-video-${index}`} className="w-full h-full">
            <video ref={el => {
          if (el) videoRefs.current[index] = el;
        }} className="h-full w-full rounded-xl object-cover pointer-events-none" width={300} height={400} autoPlay={false} muted playsInline>
              <source src={videoSrc} type="video/mp4" />
            </video>
          </CarouselItem>)}
      </CarouselContent>
      <div className="absolute inset-0 z-20 flex">
        <div className="w-1/2" onMouseDown={handleLeftMouseDown} onMouseUp={handleLeftMouseUp} onTouchStart={handleLeftMouseDown} onTouchEnd={handleLeftMouseUp} />
        <div className="w-1/2" onMouseDown={handleRightMouseDown} onMouseUp={handleRightMouseUp} onTouchStart={handleRightMouseDown} onTouchEnd={handleRightMouseUp} />
      </div>
    </Carousel>;
}
export default InstaStory;